import { Component } from '@angular/core';

interface InfoRow {
  iconKey: 'mail' | 'phone' | 'map';
  label: string;
  value: string;
  href?: string;
}

interface SocialLink {
  iconKey: 'facebook' | 'instagram' | 'whatsapp';
  href: string;
  label: string;
}

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent {
  readonly infoRows: InfoRow[] = [
    { iconKey: 'mail',  label: $localize`:@@contactInfo.rows.email.label:電郵地址`, value: 'info@chouxcreme.com.hk', href: 'mailto:info@chouxcreme.com.hk' },
    { iconKey: 'phone', label: $localize`:@@contactInfo.rows.phone.label:聯絡電話 (辦公時間內)`, value: '(852) 2690 1853', href: 'tel:+85226901853' },
    { iconKey: 'map',   label: $localize`:@@contactInfo.rows.address.label:辦公地址`, value: $localize`:@@contactInfo.rows.address.value:香港` }
  ];

  readonly socialLinks: SocialLink[] = [
    { iconKey: 'facebook',  href: 'https://facebook.com/chezchoux',  label: 'Facebook' },
    { iconKey: 'instagram', href: 'https://instagram.com/chezchoux', label: 'Instagram' },
    { iconKey: 'whatsapp',  href: 'https://wa.me/85226901853',       label: 'WhatsApp' }
  ];
}
